<!-- 基地 右侧展示的详情 -->
<style lang="stylus" scoped>
.details
  position absolute
  left 30px
  top 390px
  width 469px
  color #fff
  z-index 11
 .part-1, .part-2, .part-3
   margin-bottom 13px
   background rgba(0,36,90,1)
   border 1px solid #4975E9
 .part-1
     font-size 24px
     font-weight bold
    .nav
      display: flex
      justify-content space-around
      height 69px
      padding 20px 30px 0
      margin-bottom 40px
      cursor pointer
      .active
        color #34EBE5
        border-bottom 4px solid rgba(52,235,229,1)
    .content
      height 200px
      font-size 20px
      line-height 2
      padding 0 12px
    .content1
      text-indent 2em
    .content2
      text-align center
      overflow hidden
      .swiper-button-next, .swiper-button-prev
        width 20px
        height 23px
        top 200px
      .swiper-button-prev
        background url("../../../../static/img/base/left.png")
        background-size 100% 100%
      .swiper-button-next
        background url("../../../../static/img/base/right.png")
        background-size 100% 100%
</style>

<template>
  <div class="details">
    <div class="part-1">
      <div class="nav">
        <div
          v-for="(item, index) in navItem"
          :key="index"
          :class="[{['active']: activeIndex == index}]"
          @click="switchNav(index)"
        >{{item}}</div>
      </div>
      <div class="content content1" v-if="activeIndex === 0">广西百色翠丰特色农产品有限责任公司主要经营：水果、食用菌、田七、农副土特产品、家禽、水产品、茶叶、预包装食品贸易等产品。
</div>
      <div class="content content2" v-if="activeIndex === 1">
        <!-- <img src="static/img/base/iot.png" alt=""> -->
        <swiper :options="swiperOption" class="swiper-wrap"  ref="mySwiper" v-if="banner.length!=0">
          <swiper-slide v-for="(item,index) in banner" :key="index">
            <img :src="item" alt="" width='152px'/>
          </swiper-slide>
          <!-- 常见的小圆点 -->
          <!-- <div class="swiper-pagination"  v-for="(item,index) in banner" :key="index" slot="pagination" ></div> -->
        </swiper>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
  </div>
</template>

<script>
import '../../../../static/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import pro1 from '../../../../static/img/base/pro1.png'
import pro2 from '../../../../static/img/base/pro2.png'
import pro3 from '../../../../static/img/base/pro3.png'
import pro4 from '../../../../static/img/base/pro4.png'
import pro5 from '../../../../static/img/base/pro5.png'
import pro6 from '../../../../static/img/base/pro6.png'
export default {
  data() {
    const that = this;
    return {
      navItem: ['企业简介', '种植品种'],
      activeIndex: 0,
      content3Data: [
        {name: '土壤温度', value: '24℃'},
        {name: '土壤湿度', value: '43%'},
        {name: '土壤铵根离子', value: '1.0ppm'},
        {name: '土壤硝酸离子', value: '0ppm'},
        {name: '土壤钾离子', value: ' 41.93ppm'}
      ],
      content4Data: [
        {name: '电磁阀1', value: '开'},
        {name: '电磁阀2', value: '开'},
        {name: '电磁阀3', value: '开'}
      ],
      show: false,
      banner: [pro1, pro2, pro3, pro4, pro5, pro6],
      swiperOption: {
        slidesPerView: 2,
        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        notNextTick: true,
        // 循环
        loop: true,
        // 设定初始化时slide的索引
        initialSlide: 0,
        // 自动播放
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          /* 触摸滑动后是否继续轮播 */
          disableOnInteraction: false
        },
        // 滑动速度
        speed: 800,
        // 滑动方向
        direction: "horizontal",
        // 小手掌抓取滑动
        grabCursor: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        on: {
          // 滑动之后回调函数
          slideChangeTransitionStart: function() {
            /* realIndex为滚动到当前的slide索引值 */
            that.imgIndex = this.realIndex - 1;
          }
        }
      }
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  mounted() {

  },
  methods: {
    switchNav(index) {
      this.activeIndex = index;
    },
    showDetails() {
      this.show = true;
    },
    hideDetails() {
      this.show = false;
    }
  }
}

</script>



// WEBPACK FOOTER //
// index.vue?a040dcf2